import React, { useState } from 'react';
import { ViewUser } from './ViewUser';
import { UpdateUser } from './UpdateUser';
import { AccessPermission } from './AccessPermission';
import { DeleteUsers } from './DeleteUsers';

type Props = {
  closeMenu?: () => void;
  rowId?: number;
  openCloseState: { open: boolean; id: number | null };
};

export const ManageUsersDropdownOptions: React.FC<Props> = ({
  closeMenu,
  rowId,
  openCloseState,
}) => {
  const [openViewPopup, setOpenViewPopup] = useState<boolean>(false);
  const [openUpdatePopup, setOpenUpdatePopup] = useState<boolean>(false);
  const [openAccessPopup, setOpenAccessPopup] = useState<boolean>(false);
  const [openDeletePopup, setOpenDeletePopup] = useState<boolean>(false);

  return (
    <React.Fragment>
      {openCloseState.open && openCloseState.id === rowId && (
        <div className="RowOptionsMenuContainer">
          {rowId && closeMenu && (
            <div className="ItemsContainer">
              {/* View User */}
              <div
                className="Item"
                onClick={() => {
                  closeMenu();
                  setOpenViewPopup(true);
                }}
              >
                <span>View User</span>
              </div>

              {/* Update User */}
              <div
                className="Item"
                onClick={() => {
                  closeMenu();
                  setOpenUpdatePopup(true);
                }}
              >
                <span>Update User</span>
              </div>

              {/* Access Permission */}
              {/* <div
                className="Item"
                onClick={() => {
                  closeMenu();
                  setOpenAccessPopup(true);
                }}
              >
                <span>Access Permission</span>
              </div> */}

              {/* Delete user */}
              <div
                className="Item"
                onClick={() => {
                  closeMenu();
                  setOpenDeletePopup(true);
                }}
              >
                <span>Delete User</span>
              </div>
            </div>
          )}
        </div>
      )}

      {/* View User Panel  */}
      {openViewPopup && rowId && (
        <ViewUser
          panelOpen={openViewPopup}
          togglePanelOpen={setOpenViewPopup}
          id={rowId}
        />
      )}

      {/* Update User Panel  */}
      {openUpdatePopup && rowId && (
        <UpdateUser
          panelOpen={openUpdatePopup}
          togglePanelOpen={setOpenUpdatePopup}
          id={rowId}
        />
      )}
      {/* Access Permission Panel  */}
      {openAccessPopup && rowId && (
        <AccessPermission
          panelOpen={openAccessPopup}
          togglePanelOpen={setOpenAccessPopup}
          id={rowId}
        />
      )}

      {/* Delete User Modal  */}
      {openDeletePopup && rowId && (
        <DeleteUsers
          panelOpen={openDeletePopup}
          togglePanelOpen={setOpenDeletePopup}
          addPluralTxt={false}
          ids={[rowId]}
        />
      )}
    </React.Fragment>
  );
};
